<template>
	<div class='display-action'>
		<h2 class='display-header'>{{getText('DisplayHeader')}}</h2>
		<hr/>
		<div class='container'>
			<div class='row' v-if="action_data.bankName">
				<div class='col-sm-5 display-title'>{{getText('BankName')}}</div>
				<div class='col-sm-7 display-text'>{{action_data.bankName}}</div>
			</div>
			<div class='row' v-if="action_data.accountHolder">
				<div class='col-sm-5 display-title'>{{getText('AccountName')}}</div>
				<div class='col-sm-7 display-text'>{{action_data.accountHolder}}</div>
			</div>
			<div class='row' v-if="action_data.paymentReference">
				<div class='col-sm-5 display-title'>{{getText('PaymentReference')}}</div>
				<div class='col-sm-7 display-text'>{{action_data.paymentReference}}</div>
			</div>
			<div class='row' v-if="action_data.accountNumber">
				<div class='col-sm-5 display-title'>{{getText('AccountNumber')}}</div>
				<div class='col-sm-7 display-text'>{{action_data.accountNumber}}</div>
			</div>
			<div class='row'>
				<div class='col-sm-5 display-title'>{{getText('Amount')}}</div>
				<div class='col-sm-7 display-text'>{{rateOffer().Symbol}}{{ (invoice().amount * rateOffer().RateOffer.Rate).toFixed(rateOffer().Units) || "--"}} {{rateOffer().Currency}}</div>
			</div>
		</div>

		<hr/>
		<div class='container'>
			<div class='row' v-for="(value, key) in extra_action_data">
				<div class='col-sm-5 display-title'>{{key.replace(/[A-Z]/g, ' $&').replace(/^./, str => str.toUpperCase())}}</div>
				<div class='col-sm-7 display-text'>{{value}}</div>
			</div>
		</div>
		<div class='button-box'>
			<input class='submit-button' :value="getText('ViewStatus')" @click="return_action" >
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";

// Language / Localization
import LanguageService from "@/common/language.service";

export default {
	name: "DisplayAction",
	components: {},
	computed: {
		action_data(){
			return this.action().Display;
		},
		extra_action_data(){
			var filtered_action_data = {};
			Object.keys(this.action_data).forEach(key => {
				if(!['bankName','accountHolder','accountNumber','paymentReference'].includes(key)){
					filtered_action_data[key] = this.action_data[key];
				}
			});
			return filtered_action_data;
		}
	},
	methods: {
		getText(key){
			return LanguageService.getText(key);
		},
		return_action: function(event) {
			this.$emit('complete', 'true');
		},
		...mapGetters(["action", "rateOffer", "invoice"])
	}
}
</script>
